import ApiService from '../../utils/fetch';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const alertCategoryUrl = `${BASE_URL}alert/category`; 
const ALERT_SUBSCRIPTION_URL = `${BASE_URL}alert/subscription`;

export const fetchAlertPreferenceExceptionType = async (categoryCode) => {
    const url = `${alertCategoryUrl}/${categoryCode}`;
    const response = await ApiService.get(url);
    return response.data;
};

export const saveAlertSubscription = async (payload) => {
  try {
    const res = await ApiService.post(ALERT_SUBSCRIPTION_URL, payload);
    return res.data;
  } catch (error) {
    // ALWAYS throw the backend error so UI can catch it
    if (error.res) {
      throw error.res.data;   // <--- CRITICAL FIX
    }
    throw error;
  }
};

export const fetchRegions = async (userEmail) => {
    const url = `${BASE_URL}alert/regions`;
    const response = await ApiService.get(url);
    const regions = response.data?.content?.regions || [];
    return Array.isArray(regions) ? regions : [];
};

export const fetchPlants = async (userEmail, regions) => {
    const url = `${BASE_URL}alert/plants`;
    const payload = {
        userEmail: userEmail,
        regions: regions
    };
    const response = await ApiService.post(url, payload);
    const plants = response.data?.content?.plants || [];
    return Array.isArray(plants) ? plants : [];
};

export const fetchMaterialTypes = async (plants) => {
    const url = `${BASE_URL}alert/materialsType`;
    const response = await ApiService.post(url, plants);
    const materialTypes = response.data?.content?.materialType || [];
    return Array.isArray(materialTypes) ? materialTypes : [];
};

export const fetchMrpControllers = async (plants, materialType) => {
    const url = `${BASE_URL}alert/mrpController`;
    const payload = {
        plants: plants,
        materialType: materialType
    };
    const response = await ApiService.post(url, payload);
    const mrpControllers = response.data?.content?.mrpControllers || [];
    return Array.isArray(mrpControllers) ? mrpControllers : [];
};

export const fetchMaterials = async (
  plants,
  materialType,
  mrpController,
  category,
  options = {}
) => {
  const url = `${BASE_URL}alert/materials`;

  const {
    page = 0,
    size = 50,
    searchText = "",
  } = options;

  const payload = {
    plants,
    materialType,
    mrpController:
      Array.isArray(mrpController) && mrpController.length === 0
        ? null
        : Array.isArray(mrpController) && mrpController.every(v => v == null)
        ? null
        : mrpController,
    category,
    page,
    size,
    searchText,
  };

  const response = await ApiService.post(url, payload);
  const materials = response.data?.content?.materials || [];

  return Array.isArray(materials) ? materials : [];
};


// Update an existing alert subscription by id
export const updateAlertSubscription = async (alertId, payload) => {
    try {
        const url = `${BASE_URL}alert/subscriptions/${alertId}`;
        const res = await ApiService.put(url, payload);
        return res.data;
    } catch (error) {
        if (error.res) {
            throw error.res.data;
        }
        throw error;
    }
};

export const deleteAlertSubscription = async (alertId) => {
    try {
        const url = `${BASE_URL}alert/subscriptions/${alertId}`;
        const res = await ApiService.delete(url);
        return res.data;
    } catch (error) {
        if (error.res) {
            throw error.res.data;
        }
        throw error;
    }
};